// extracted by mini-css-extract-plugin
module.exports = {"panel_default":"panel_panel_default__1ZetI","primary-h":"panel_primary-h__2yu0E"};